import { render } from "./InterfacePersistentMessages.vue?vue&type=template&id=1aeef98c&scoped=true"
import script from "./InterfacePersistentMessages.vue?vue&type=script&lang=js"
export * from "./InterfacePersistentMessages.vue?vue&type=script&lang=js"

import "./InterfacePersistentMessages.vue?vue&type=style&index=0&id=1aeef98c&scoped=true&lang=scss"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeef98c"]])

export default __exports__